import * as S from "./ModalDialog.styles";
import useWindowResize from "../../../../hooks/useWindowResize";

const ModalDialog = ({
  open,
  forceBottomSheet,
  width = "full",
  minWidth,
  height = "auto",
  overflow = "auto",
  backgroundColor = "white",
  onClose,
  children,
  ...restProps
}) => {
  const windowSize = useWindowResize();

  const isMobile = windowSize <= 545;

  const isBottomSheet = isMobile || forceBottomSheet;

  return (
    <S.ModalDialogCustom
      open={open}
      onClose={onClose}
      $isBottomSheet={isBottomSheet}
      $width={width}
      $minWidth={minWidth}
      $height={height}
      $overflow={overflow}
      $backgroundColor={backgroundColor}
      {...restProps}
    >
      {children}
    </S.ModalDialogCustom>
  );
};

export default ModalDialog;
